import React, { FC, useState, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation, useQuery } from 'react-query';
import { useHistory, useParams } from 'react-router';
import { useForm, Controller } from 'react-hook-form';
import DoneIcon from '@material-ui/icons/Done';
import {
  Paper,
  Grid,
  Container,
  Button,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import { useStyles } from './styles';
import { UserFormInputPattern, EndUserData, GenericFormProps } from './types';
import { observer } from 'mobx-react-lite';
import { Autocomplete } from '@mui/material';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { OrganizationParamUrl } from 'containers/SignInEndUser/types';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
export const EndUserGenericForm: FC<GenericFormProps> = observer(({ selfRegister, type }) => {
  const classes = useStyles();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
  const [registrationStep, setRegistrationStep] = useState<number>(1);
  const [step1Data, setStep1Data] = useState<any>(null);
  const [email, setMail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [uid, setUid] = useState('');
  const [userpassword, setUserpassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [valid, setValid] = useState<any>();
  const [focused] = useState<any>({ type: '', isfocused: false });
  const [emailValid, setEmailValid] = useState<any>();
  const [confirmEmailValid, setConfirmEmaiValid] = useState<any>();
  const { domain } = useParams<OrganizationParamUrl>();
  const [passLowerCase, setPassLowerCase] = useState<number>(0);
  const [passUpperCase, setPassUpperCase] = useState<number>(0);
  const [passNumericCase, setPassNumericCase] = useState<number>(0);
  const [passSpecialCase, setPassSpecialCase] = useState<number>(0);
  const [minPass, SetMinPass] = useState<number>(0);
  const [serverErrors, setServerErrors] = useState<any>({});
  const [loginUrl, setLoginUrl] = useState<string | null>(null);
  // const [loading, setLoading] = useState(true);
  const handleValidation = (e: any) => {
    const reg = /^[A-Za-z]+$/;
    setValid(reg.test(e.target.value));
  };

  const handleUserIDValidation = (e: any) => {
    const value = e.target.value;
    const reg = new RegExp(/^[a-zA-Z0-9_]+$/);
    const isValid = reg.test(value) && value.trim() !== '';
    setValid(isValid);
  };
  const handleEmailValidation = (e: any, type: string) => {
    const reg = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
    if (type === 'email') {
      setEmailValid(reg.test(e.target.value));
    } else {
      setConfirmEmaiValid(reg.test(e.target.value));
    }
  };
  const googleData = JSON.parse(localStorage.getItem('googleRegister') as string);
  const [emailValue, setEmailValue] = useState('');

  useEffect(() => {
    if (googleData) {
      setEmailValue(googleData.user.email);
    }
  }, [googleData]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        const currentSubdomain = parts.length > 1 && hostname !== 'localhost' ? parts[0] : '';
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}auth/google-registration/redirect-url?domain=${currentSubdomain}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              fqdn: currentSubdomain || 'googleAuth',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.includes('application/json')) {
          const responseData = await response.json();
          setLoginUrl(responseData?.url || null);
          // setLoading(false);
        } else {
          const responseData = await response.text();
          setLoginUrl(responseData);
          // setLoading(false);
        }
      } catch (error) {
        // setLoading(false);
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const { control, handleSubmit, reset } = useForm<EndUserData>();
  useEffect(() => {
    if (emailValue) {
      const EndUserData: EndUserData = {
        email: emailValue ?? '',
        uid: '',
        confirmEmail: emailValue ?? '',
        password: '',
        confirmPassword: '',
        name: '',
        givenname: '',
        sn: '',
        attr: '',
        customAttribute: [],
      };
      setMail(emailValue);
      setConfirmEmail(emailValue);
      setEmailValid(emailValue);
      setConfirmEmaiValid(emailValue);
      reset(EndUserData);
    }
  }, [emailValue, reset, setEmailValid, setConfirmEmaiValid]);

  const {
    ldapStore: { clickedUser, createEndUser, getGroupsAndDepartmentsForSelfRegister, departmentView, groupView },
    endUserSettingsFormStore: { getPortalSettings, getSetting, settingsByTypeView, CustomAttributeget, attributeKey },
    notificationStore: { openNotification },
    appPreloaderStore: { disablePreloader },
  } = useStore();
  const attributegetReq = useQuery('attributegetReq', () => CustomAttributeget(), {
    onError: () => openNotification('error', `Can't get data`),
  });

  const getSettingsReq = useQuery('getSettingsReq', () => getSetting(), {
    onError: () => openNotification('error', `Can't get settings data`),
  });
  const getGroupsAndDepartmentsReq = useQuery(
    'getGroupsAndDepartmentsReq',
    () => getGroupsAndDepartmentsForSelfRegister(),
    {
      onError: () => openNotification('error', `Can't get groups and departments`),
    }
  );

  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    onError: () => openNotification('error', `Can't get data`),
  });

  const endUserConfigSettings = JSON.parse(localStorage.getItem('endUserConfigSettings') as string);
  useAppPreloader(getSettingsReq.isFetching || portalSettingsgetReq.isFetching);
  const createUserReqStep1 = useMutation(
    (data: { email: string; confirmEmail: string; uid: string; password: string; confirmPassword: string }) => {
      setStep1Data(data);
      return Promise.resolve();
    },
    {
      mutationKey: 'createUserReqStep1',
      onSuccess: () => {
        setRegistrationStep(2);
        openNotification('success', 'Details Confirmed');
      },
      onError: (error: any) => {
        if (error.response?.data?.errors) {
          setServerErrors(error.response.data.errors);
        }
        openNotification('error', error.message || 'Validation failed');
      },
    }
  );
  const createUserReq = useMutation(
    (data: EndUserData) => {
      return createEndUser(data);
    },
    {
      mutationKey: 'createUserReq',
      onSuccess: () => {
        setServerErrors({});
        openNotification('success', 'Created Successfully');
        if (!selfRegister) {
          history.push(handleCompanyUrl('/users'));
        } else {
          disablePreloader();
          history.push(handleCompanyUrl('/login'));
          const redirectUrl = handleCompanyUrl('/login');
          history.push(redirectUrl);
        }
      },
      onError: (error: any) => {
        if (error.response?.data?.errors) {
          setServerErrors(error.response.data.errors);
        }
        const errorMessage = error.response?.data?.message || error.message || 'Failed to create user';
        openNotification('error', errorMessage);
      },
    }
  );
  const passwordPattern = new RegExp(
    `^(?=(?:.*[A-Z]){${passUpperCase},})(?=(?:.*[a-z]){${passLowerCase},})(?=(?:.*\\d){${passNumericCase},})(?=(?:.*[!@#$%^&*()_+={}[]|\\:;"'<>,.?/~\`-]){${passSpecialCase},}).{${minPass},}$`
  );
  const isStrongPassword = (password: any) => {
    return passwordPattern.test(password);
  };
  useEffect(() => {
    settingsByTypeView('password').forEach((group: any, i: any) =>
      group.settings.forEach((setting: any, j: any) => {
        if (setting.key === 'minimumNumberOfLowercaseCharacters') {
          return setPassLowerCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfUppercaseCharacters') {
          return setPassUpperCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfNumericCharacters') {
          return setPassNumericCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfSpecialCharacters') {
          return setPassSpecialCase(+setting.value);
        } else if (setting.key === 'minimumLengthPassword') {
          return SetMinPass(+setting.value);
        } else {
          return 0;
        }
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSettingsReq.isFetching]);
  useAppPreloader(createUserReq.isLoading || createUserReqStep1.isLoading || attributegetReq.isFetching);
  const onNext = (data: {
    email: string;
    confirmEmail: string;
    uid: string;
    password: string;
    confirmPassword: string;
  }) => {
    return createUserReqStep1.mutate(data);
  };
  const onSubmit = (data: EndUserData) => {
    const customAttributes = attributeKey.map((attr: any) => ({
      label: attr.label,
      type: attr.type,
      name: attr.name,
      options: attr.options || [],
      value: data[attr.name as keyof EndUserData] || null,
    }));
    attributeKey.forEach((attr: any) => {
      delete data[attr.name as keyof EndUserData];
    });
    data.customAttribute = customAttributes;
    const finalData = {
      ...step1Data,
      ...data,
      name: `${data.givenname || ''} ${data.sn || ''}`.trim(),
      domain: domain || window.location.hostname.split('.')[0],
    };
    return createUserReq.mutate(finalData);
  };
  const mockDataPers2: UserFormInputPattern[] = [
    { label: 'First name', key: 'givenname', required: true, autoFocus: true },
    { label: 'Middle name', key: 'displayname', required: false },
    { label: 'Last name', key: 'sn', required: true },
    { label: 'Phone (Optional)', type: 'phone', key: 'phone', required: false },
    { label: 'Department (Optional)', key: 'department', required: false },
    { label: 'Group (Optional)', key: 'group', required: false },
  ];

  const mockDataPers1: UserFormInputPattern[] = [
    { label: 'Email', key: 'email', required: true, autoFocus: true, disable: emailValue ? true : false },
    { label: 'Re-type Email', key: 'confirmEmail', required: true, disable: emailValue ? true : false },
    {
      label:
        endUserConfigSettings?.userId === null || endUserConfigSettings?.userId === ''
          ? 'UserID'
          : endUserConfigSettings?.userId,
      key: 'uid',
      required: true,
      pattern: {
        regexp: /^[0-9a-z_]+$/,
        errorMessage: 'This field must contain only digits, lowercase letters or underscores',
      },
    },
    { label: 'Password', type: 'password', key: 'password', required: !clickedUser as boolean },
    { label: 'Re-type Password', type: 'password', key: 'confirmPassword', required: !clickedUser as boolean },
  ];
  return (
    <>
      {settingsByTypeView(type).map((group, i) => {
        return (
          <React.Fragment key={i}>
            {group.settings.map((setting, j) => {
              return (
                <React.Fragment key={j}>
                  {setting.description === 'Enable Self-Service Account Registration' &&
                  (setting.value === '0' || setting.value === '') ? (
                    <Grid className={classes.alertmessage}>
                      <div className={classes.alertbox}>
                        <div>
                          <ErrorOutlineIcon className={classes.alertIcon} />
                        </div>
                        <div>
                          <div className={classes.alertTitle}>Administrator did not enable these services</div>
                        </div>
                      </div>
                    </Grid>
                  ) : setting.description === 'Enable Self-Service Account Registration' && setting.value === '1' ? (
                    <React.Fragment>
                      <form
                        onSubmit={registrationStep === 1 ? handleSubmit(onNext) : handleSubmit(onSubmit)}
                        className={classes.box}
                      >
                        <Grid container justify='center'>
                          <div className={classes.topBar}>
                            <div className={classes.flex}>
                              {registrationStep === 1 ? (
                                <div className={classes.circle}>1</div>
                              ) : (
                                <div style={{ backgroundColor: '#64C968' }} className={classes.circle}>
                                  <DoneIcon className={classes.icon} />
                                </div>
                              )}
                              <div className={classes.activeText}>Account</div>
                            </div>
                            <div className={classes.horizontalLine}>
                              <hr className={classes.hr} />
                            </div>
                            <div className={classes.flex}>
                              <div className={registrationStep === 1 ? classes.disabledCircle : classes.circle}>2</div>
                              <div className={registrationStep === 1 ? classes.disabledText : classes.activeText}>
                                About
                              </div>
                            </div>
                          </div>
                          <Paper className={classes.paper}>
                            <p className={classes.boxTitle}>Sign Up</p>
                            {loginUrl && loginUrl !== '' && (
                              <>
                                <Button
                                  fullWidth
                                  variant='outlined'
                                  // onClick={handleGoogleSignup}
                                  style={{
                                    height: '48px',
                                    marginBottom: '20px',
                                    textTransform: 'none',
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    borderColor: '#dadce0',
                                  }}
                                >
                                  <img
                                    src='https://developers.google.com/identity/images/g-logo.png'
                                    alt='Google'
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      marginRight: '10px',
                                    }}
                                  />
                                  <a href={loginUrl}>Sign in with Google</a>
                                </Button>
                                <span className={classes.titles} style={{ marginBottom: '20px' }}>
                                  OR
                                </span>
                              </>
                            )}
                            {/* <>
                              <Button
                                fullWidth
                                variant="outlined"
                                // onClick={handleGoogleSignup}
                                style={{
                                  height: '48px',
                                  marginBottom: '20px',
                                  textTransform: 'none',
                                  fontSize: '16px',
                                  fontWeight: 500,
                                  borderColor: '#dadce0',
                                }}
                              >
                                <img
                                  src="https://developers.google.com/identity/images/g-logo.png"
                                  alt="Google"
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    marginRight: '10px',
                                  }}
                                />
                                 <a href={loginUrl}>Sign in with Google</a>
                              </Button>
                              <span style={{ marginBottom: '20px' }} >OR</span>
                            </> */}
                            {registrationStep === 1 && (
                              <Grid container>
                                <Container className={classes.tableBox}>
                                  {mockDataPers1.map((item, index) => (
                                    <Controller
                                      key={item.key}
                                      name={item.key}
                                      control={control}
                                      rules={{ required: item?.required }}
                                      render={({ field, fieldState: { invalid, error } }) => (
                                        <Grid
                                          key={index}
                                          container
                                          className={item?.multiline ? classes.rowWide : classes.row}
                                        >
                                          {item.type === 'password' ? (
                                            <FormControl
                                              className={invalid ? classes.inputError : classes.input}
                                              required
                                            >
                                              <InputLabel variant='outlined' htmlFor={item?.key}>
                                                {item.label}
                                              </InputLabel>
                                              <OutlinedInput
                                                {...field}
                                                error={invalid || userpassword !== confirmPassword}
                                                id={item?.key}
                                                label={item?.label}
                                                fullWidth
                                                value={field.value}
                                                onChange={(e) => {
                                                  field.onChange(e);
                                                  item?.key === 'password'
                                                    ? setUserpassword(e.target.value)
                                                    : item?.key === 'confirmPassword'
                                                    ? setConfirmPassword(e.target.value)
                                                    : console.log('failed to get password');
                                                }}
                                                required={item?.required}
                                                type={
                                                  item?.key === 'confirmPassword'
                                                    ? showConfirmPassword
                                                      ? 'text'
                                                      : 'password'
                                                    : showPassword
                                                    ? 'text'
                                                    : 'password'
                                                }
                                                endAdornment={
                                                  <InputAdornment position='end'>
                                                    <IconButton
                                                      aria-label='toggle password visibility'
                                                      onClick={
                                                        item?.key === 'confirmPassword'
                                                          ? () => setShowConfirmPassword(!showConfirmPassword)
                                                          : () => setShowPassword(!showPassword)
                                                      }
                                                    >
                                                      {item?.key === 'confirmPassword' ? (
                                                        showConfirmPassword ? (
                                                          <Visibility />
                                                        ) : (
                                                          <VisibilityOff />
                                                        )
                                                      ) : showPassword ? (
                                                        <Visibility />
                                                      ) : (
                                                        <VisibilityOff />
                                                      )}
                                                    </IconButton>
                                                  </InputAdornment>
                                                }
                                              />
                                              {userpassword !== confirmPassword ? (
                                                <FormHelperText error id={item?.key}>
                                                  Confirm Password does not match
                                                </FormHelperText>
                                              ) : !isStrongPassword(userpassword) ? (
                                                <FormHelperText error id={item?.key}>
                                                  Password must contain at least {passUpperCase} uppercase,{' '}
                                                  {passLowerCase} lowercase, {passSpecialCase} special characters,{' '}
                                                  {passNumericCase} numeric value(s), and minimum ${minPass} characters.
                                                </FormHelperText>
                                              ) : null}
                                            </FormControl>
                                          ) : item.type === 'phone' ? (
                                            <FormControl className={invalid ? classes.inputError : classes.borderClass}>
                                              <MuiPhoneNumber
                                                className={invalid ? classes.inputError : classes.borderClass}
                                                {...field}
                                                error={invalid}
                                                variant='outlined'
                                                fullWidth
                                                name={item?.key}
                                                label={item?.label}
                                                required={item?.required}
                                                data-cy='user-phone'
                                                defaultCountry={'us'}
                                                classes='input-danger'
                                              />
                                            </FormControl>
                                          ) : item?.key === 'email' ? (
                                            <TextField
                                              {...field}
                                              autoFocus={item?.autoFocus}
                                              variant='outlined'
                                              className={emailValid ? classes.inputError : classes.input}
                                              multiline={item?.multiline}
                                              label={item?.label}
                                              value={field.value}
                                              onChange={(e) => {
                                                setMail(e.target.value);
                                                handleEmailValidation(e, 'email');
                                                field.onChange(e);
                                              }}
                                              required
                                              rows={item?.multiline ? 4 : 1}
                                              placeholder={item.placeholder}
                                              type={item.type ? item.type : undefined}
                                              error={!emailValid || item.key === focused.type}
                                              disabled={item.disable}
                                              helperText={
                                                !emailValid && item.key === 'email' && email !== ''
                                                  ? 'Please enter valid email address'
                                                  : invalid
                                                  ? error?.type === 'pattern'
                                                    ? item.pattern?.errorMessage
                                                    : 'Required field'
                                                  : ' '
                                              }
                                            />
                                          ) : item?.key === 'confirmEmail' ? (
                                            <TextField
                                              {...field}
                                              autoFocus={item?.autoFocus}
                                              variant='outlined'
                                              className={invalid ? classes.inputError : classes.input}
                                              multiline={item?.multiline}
                                              label={item?.label}
                                              value={field.value}
                                              onChange={(e) => {
                                                setConfirmEmail(e.target.value);
                                                handleEmailValidation(e, 'confirmEmail');
                                                field.onChange(e);
                                              }}
                                              required={item?.required}
                                              rows={item?.multiline ? 4 : 1}
                                              placeholder={item.placeholder}
                                              type={item.type ? item.type : undefined}
                                              disabled={item.disable}
                                              error={
                                                !confirmEmailValid ||
                                                item.key === focused.type ||
                                                email !== confirmEmail
                                              }
                                              helperText={
                                                !confirmEmailValid && item.key === 'confirmEmail' && confirmEmail !== ''
                                                  ? 'Please enter valid email address'
                                                  : email !== confirmEmail
                                                  ? 'Confirm Email not matched'
                                                  : invalid
                                                  ? error?.type === 'pattern'
                                                    ? item.pattern?.errorMessage
                                                    : 'Required field'
                                                  : ' '
                                              }
                                            />
                                          ) : item?.key === 'uid' ? (
                                            <TextField
                                              {...field}
                                              autoFocus={item?.autoFocus}
                                              variant='outlined'
                                              className={invalid ? classes.inputError : classes.input}
                                              multiline={item?.multiline}
                                              label={item?.label}
                                              value={field.value}
                                              onChange={(e: any) => {
                                                setUid(e.target.value);
                                                handleUserIDValidation(e);
                                                field.onChange(e);
                                              }}
                                              rows={item?.multiline ? 4 : 1}
                                              placeholder={item.placeholder}
                                              type={item.type ? item.type : undefined}
                                              error={invalid || (valid === false && uid !== '')}
                                              helperText={(() => {
                                                // Check for server error first
                                                if (serverErrors.uid && serverErrors.uid.length > 0) {
                                                  return serverErrors.uid[0];
                                                }
                                                const uidRegex = /^[a-zA-Z0-9_]+$/;
                                                const isUidValid = uid === '' || uidRegex.test(uid);
                                                if (!isUidValid && uid !== '') {
                                                  return 'UID must contain only letters, numbers, and underscores';
                                                }
                                                if (invalid) {
                                                  return error?.type === 'pattern'
                                                    ? item.pattern?.errorMessage
                                                    : 'Required field';
                                                }
                                                return ' ';
                                              })()}
                                            />
                                          ) : (
                                            <TextField
                                              {...field}
                                              autoFocus={item?.autoFocus}
                                              variant='outlined'
                                              className={invalid ? classes.inputError : classes.input}
                                              multiline={item?.multiline}
                                              label={item?.label}
                                              value={uid}
                                              onChange={(e) => {
                                                setUid(e.target.value);
                                              }}
                                              required={item?.required}
                                              rows={item?.multiline ? 4 : 1}
                                              placeholder={item.placeholder}
                                              type={item.type ? item.type : undefined}
                                              error={invalid}
                                              helperText={
                                                invalid
                                                  ? error?.type === 'pattern'
                                                    ? item.pattern?.errorMessage
                                                    : 'Required field'
                                                  : ''
                                              }
                                            />
                                          )}
                                        </Grid>
                                      )}
                                    />
                                  ))}
                                  {/* <div className={classes.captcha}>
                                <Reaptcha
                                  className={classes.recaptcha}
                                  sitekey='6LdjPPIgAAAAAOceFAN1uID-_6RAbllD2E4bfWRb'
                                  onVerify={() => {
                                    setIsVerified(true);
                                  }}
                                  onExpire={() => {
                                    setIsVerified(false);
                                  }}
                                />
                              </div> */}
                                </Container>
                                <Button
                                  disabled={!emailValid || email !== confirmEmail || userpassword !== confirmPassword}
                                  className={classes.button}
                                  variant='contained'
                                  color='primary'
                                  type='submit'
                                >
                                  NEXT
                                </Button>
                              </Grid>
                            )}
                            {registrationStep === 2 && (
                              <Grid container>
                                <Container className={classes.tableBox}>
                                  {mockDataPers2.map((item, index) => (
                                    <Controller
                                      key={index}
                                      name={item.key}
                                      control={control}
                                      rules={{
                                        required: item?.required,
                                        pattern:
                                          item.key === 'givenname' || item.key === 'sn' || item.key === 'displayname'
                                            ? {
                                                value: /^[A-Za-z]+$/,
                                                message:
                                                  'There must be no space in start and numeric value and special character',
                                              }
                                            : undefined,
                                      }}
                                      render={({ field, fieldState: { invalid, error } }) => (
                                        <Grid
                                          key={index}
                                          container
                                          className={item?.multiline ? classes.rowWide : classes.row}
                                        >
                                          {item.type === 'password' ? (
                                            <FormControl
                                              className={invalid ? classes.inputError : classes.input}
                                              required
                                            >
                                              <InputLabel variant='outlined' htmlFor={item.key}>
                                                {item.label}
                                              </InputLabel>
                                              <OutlinedInput
                                                {...field}
                                                error={invalid}
                                                id={item?.key}
                                                label={item?.label}
                                                fullWidth
                                                required={item?.required}
                                                type={showPassword ? 'text' : 'password'}
                                                endAdornment={
                                                  <InputAdornment position='end'>
                                                    <IconButton
                                                      aria-label='toggle password visibility'
                                                      onClick={() => setShowPassword(!showPassword)}
                                                    >
                                                      {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                  </InputAdornment>
                                                }
                                              />
                                            </FormControl>
                                          ) : item.type === 'phone' ? (
                                            <FormControl className={invalid ? classes.inputError : classes.input}>
                                              <MuiPhoneNumber
                                                className={invalid ? classes.inputError : classes.input}
                                                {...field}
                                                error={invalid}
                                                variant='outlined'
                                                fullWidth
                                                name={item?.key}
                                                label={item?.label}
                                                required={item?.required}
                                                data-cy='user-phone'
                                                defaultCountry={'us'}
                                              />
                                            </FormControl>
                                          ) : item.key === 'department' ? (
                                            !getGroupsAndDepartmentsReq.isFetching && departmentView.length > 0 ? (
                                              <Grid className={classes.row} container justify='space-between'>
                                                <Controller
                                                  name={item?.key}
                                                  control={control}
                                                  render={({ field }) => (
                                                    <Autocomplete
                                                      {...field}
                                                      fullWidth
                                                      // placeholder={item.placeholder}
                                                      options={departmentView}
                                                      className={invalid ? classes.inputError : classes.input}
                                                      renderInput={(params) => (
                                                        <TextField {...params} variant='outlined' label={item?.label} />
                                                      )}
                                                      getOptionLabel={(option) => option.ou || ''}
                                                      onChange={(e, value) => {
                                                        const selectedValue = value ? `/${value.ou}` || '' : '';
                                                        field.onChange(selectedValue);
                                                      }}
                                                      value={
                                                        departmentView.find(
                                                          (option) => `/${option.ou}` === field.value
                                                        ) || null
                                                      }
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                            ) : null
                                          ) : item.key === 'group' ? (
                                            <>
                                              {!getGroupsAndDepartmentsReq.isFetching &&
                                              groupView &&
                                              groupView.length > 0 ? (
                                                <Grid className={classes.row} container justify='space-between'>
                                                  <Controller
                                                    name={item?.key}
                                                    control={control}
                                                    render={({ field }) => (
                                                      <Autocomplete
                                                        {...field}
                                                        fullWidth
                                                        // placeholder={item.placeholder}
                                                        options={groupView}
                                                        className={invalid ? classes.inputError : classes.input}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            variant='outlined'
                                                            placeholder={item.placeholder}
                                                            label={item?.label}
                                                          />
                                                        )}
                                                        getOptionLabel={(option) => option.cn || ''}
                                                        onChange={(e, value) => {
                                                          const selectedValue = value ? value.cn || '' : '';
                                                          field.onChange(selectedValue);
                                                        }}
                                                        value={
                                                          groupView.find((option) => option.cn === field.value) || null
                                                        }
                                                      />
                                                    )}
                                                  />
                                                </Grid>
                                              ) : null}
                                            </>
                                          ) : (
                                            <TextField
                                              {...field}
                                              autoFocus={item?.autoFocus}
                                              variant='outlined'
                                              className={invalid ? classes.inputError : classes.input}
                                              multiline={item?.multiline}
                                              label={item?.label}
                                              required={item?.required}
                                              rows={item?.multiline ? 4 : 1}
                                              placeholder={item.placeholder}
                                              value={field.value}
                                              onChange={(e) => {
                                                handleValidation(e);
                                                field.onChange(e);
                                              }}
                                              type={item.type ? item.type : undefined}
                                              error={invalid}
                                              helperText={error ? error.message : ' '}
                                            />
                                          )}
                                        </Grid>
                                      )}
                                    />
                                  ))}
                                  {attributeKey?.length > 0
                                    ? attributeKey.map((attr: any) => (
                                        <>
                                          {attr.type === 'select' ? (
                                            <>
                                              <Controller
                                                name={attr.name}
                                                control={control}
                                                render={({ field }) => (
                                                  <Grid container className={classes.row}>
                                                    <Autocomplete
                                                      {...field}
                                                      fullWidth
                                                      options={attr.options || []}
                                                      className={classes.input}
                                                      renderInput={(params) => (
                                                        <TextField {...params} variant='outlined' label={attr.label} />
                                                      )}
                                                      getOptionLabel={(option) => option}
                                                      value={
                                                        attr.options?.find((opt: any) => opt === field.value) || null
                                                      }
                                                      onChange={(_, newValue) => field.onChange(newValue)}
                                                    />
                                                  </Grid>
                                                )}
                                              />
                                            </>
                                          ) : attr.type === 'checkbox' ? (
                                            <>
                                              <p>{attr.label}</p>
                                              <div style={{ marginBottom: '28px' }}>
                                                {Array.isArray(attr.options) ? (
                                                  <Controller
                                                    name={attr.name}
                                                    control={control}
                                                    render={({ field }) => {
                                                      const selectedValues = field.value
                                                        ? field.value
                                                            .split(',')
                                                            .map((v: string) => v.trim())
                                                            .filter(Boolean)
                                                        : [];
                                                      return attr.options.map((option: string) => {
                                                        const isChecked = selectedValues.includes(option);
                                                        return (
                                                          <FormControlLabel
                                                            key={option}
                                                            // disabled={type === 'view'}
                                                            control={
                                                              <Checkbox
                                                                checked={isChecked}
                                                                onChange={(e) => {
                                                                  const newValues = e.target.checked
                                                                    ? [...selectedValues, option]
                                                                    : selectedValues.filter(
                                                                        (val: string) => val !== option
                                                                      );
                                                                  field.onChange(newValues.join(','));
                                                                }}
                                                              />
                                                            }
                                                            label={option}
                                                          />
                                                        );
                                                      });
                                                    }}
                                                  />
                                                ) : (
                                                  <p>No options available</p>
                                                )}
                                              </div>
                                            </>
                                          ) : attr.type === 'date' ? (
                                            <Controller
                                              key={attr.name}
                                              name={attr.name}
                                              control={control}
                                              rules={{ required: 'Date is required' }}
                                              render={({ field, fieldState }) => (
                                                <Grid container className={classes.row}>
                                                  <TextField
                                                    {...field}
                                                    type='date'
                                                    variant='outlined'
                                                    label={attr.label}
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}
                                                  />
                                                </Grid>
                                              )}
                                            />
                                          ) : (
                                            <Controller
                                              key={attr.name}
                                              name={attr.name}
                                              control={control}
                                              rules={{ required: false }}
                                              render={({ field, fieldState: { invalid, error } }) => (
                                                <Grid container className={classes.row}>
                                                  <TextField
                                                    style={{ marginBottom: '10px' }}
                                                    {...field}
                                                    variant='outlined'
                                                    label={attr.label}
                                                    className={invalid ? classes.inputError : classes.input}
                                                    error={invalid}
                                                    helperText={
                                                      invalid ? (error?.type === 'pattern' ? '' : 'Required field') : ''
                                                    }
                                                  />
                                                </Grid>
                                              )}
                                            />
                                          )}
                                        </>
                                      ))
                                    : null}
                                </Container>
                                <div style={{ display: 'flex', width: '100%' }}>
                                  <Button
                                    className={classes.buttonGrpSecondary}
                                    onClick={() => {
                                      setRegistrationStep(1);
                                    }}
                                  >
                                    BACK
                                  </Button>
                                  <Button
                                    type='submit'
                                    disabled={!valid}
                                    className={classes.buttonGrp}
                                    variant='contained'
                                    color='primary'
                                  >
                                    SUBMIT
                                  </Button>
                                </div>
                              </Grid>
                            )}
                          </Paper>
                        </Grid>
                      </form>
                    </React.Fragment>
                  ) : null}
                </React.Fragment>
              );
            })}
          </React.Fragment>
        );
      })}
    </>
  );
});
